module.exports = __webpack_public_path__ + "static/media/68 - LOGO PPIA UNSW.5905569a.png";